import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

interface DelomradetypeFilterState {
    /** delområdetype-keys som skal SKJULES (matcher Område.id fra useAdminAreas). */
    excluded: string[];
}

const STORAGE_KEY = 'origo-drommeplan-admin-excluded-delomradetyper';

const getStoredExcluded = (): string[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
    } catch {
        return [];
    }
};

const setStoredExcluded = (ids: readonly string[]): void => {
    try {
        if (ids.length === 0) {
            localStorage.removeItem(STORAGE_KEY);
        } else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
        }
    } catch {
        // localStorage unavailable
    }
};

const initialState: DelomradetypeFilterState = {
    excluded: getStoredExcluded(),
};

const delomradetypeFilterSlice = createSlice({
    name: 'delomradetypeFilter',
    initialState,
    reducers: {
        toggleDelomradetype(state, action: PayloadAction<string>) {
            const id = action.payload;
            const idx = state.excluded.indexOf(id);
            if (idx >= 0) {
                state.excluded.splice(idx, 1);
            } else {
                state.excluded.push(id);
            }
            setStoredExcluded(state.excluded);
        },
        setExcluded(state, action: PayloadAction<string[]>) {
            state.excluded = [...action.payload];
            setStoredExcluded(state.excluded);
        },
        clearAll(state) {
            state.excluded = [];
            setStoredExcluded(state.excluded);
        },
    },
});

export const { toggleDelomradetype, setExcluded, clearAll } = delomradetypeFilterSlice.actions;

export const selectExcludedDelomradetyper = (state: RootState): string[] =>
    state.delomradetypeFilter.excluded;

export const selectExcludedCount = (state: RootState): number =>
    state.delomradetypeFilter.excluded.length;

export default delomradetypeFilterSlice.reducer;
